import { FC, useEffect } from "react";
import { useDispatch } from "react-redux";
import { GetProgramFeeResponse } from "../../../../../../../../api/services/common/models";
import {
  useGetProgramDetailById,
  useGetProgramFeeDetails,
} from "../../../../../../../../api/services/program/programApis";
import { MuiModal } from "../../../../../../../../components";
import { COMPONENT_IDS } from "../../../../../../../../helpers/constants/componentIds";
import { useSiteCore } from "../../../../../../../../hooks/useSiteCore";
import {
  toggleLoader,
  toggleToast,
} from "../../../../../../../../redux/slices/appState/appStateSlice";
import { ViewProgramFee } from "../../../../../../../viewProgram/components/programAndParticipant/tabs/participant/components/viewProgramFee/ViewProgramFee";
import { programSiteCoreKeys } from "../../../../../../siteCore/SiteCoreKeys";

interface ViewProgramFeeModalProps {
  open: boolean;
  onClose: () => void;
  programId: string;
}

const pageId = COMPONENT_IDS.VIEW_PROGRAM_FEE_MODAL;

export const ViewProgramFeeModal: FC<ViewProgramFeeModalProps> = ({
  open,
  onClose,
  programId,
}) => {
  const { commonLabels, fetchLabel } = useSiteCore();
  const dispatch = useDispatch();

  const {
    data: programFeeDetailsData,
    isFetching: isProgramFeeDetailsPending,
    isError: isProgramFeeDetailsError,
    refetchWithParams: getProgramFeeByProgramId,
  } = useGetProgramFeeDetails();

  const {
    data: generalDetail,
    isFetching: isProgramFetching,
    isError: isProgramError,
    refetchWithParams: refetchProgramDetail,
  } = useGetProgramDetailById();

  useEffect(() => {
    getProgramFeeByProgramId(programId);
  }, [programId]);

  useEffect(() => {
    if (isProgramError || isProgramFeeDetailsError) {
      dispatch(
        toggleToast({
          open: true,
          message: commonLabels.someThingWentWrongPleaseTryAgainLater,
          type: "error",
        }),
      );
      dispatch(toggleLoader({ isVisible: false }));
    }
  }, [isProgramError, isProgramFeeDetailsError]);

  useEffect(() => {
    dispatch(
      toggleLoader({
        isVisible: isProgramFetching || isProgramFeeDetailsPending,
        message: commonLabels.loadingPleaseWait,
      }),
    );
    return () => {
      dispatch(toggleLoader({ isVisible: false }));
    };
  }, [isProgramFetching, isProgramFeeDetailsPending]);

  useEffect(() => {
    if (programId) {
      refetchProgramDetail(programId);
    }
  }, [programId]);

  return (
    <MuiModal
      open={open}
      onClose={onClose}
      title={fetchLabel(
        programSiteCoreKeys.programFeeTitle,
        programSiteCoreKeys.viewProgramFeeHeader,
      )}
      hasLargeContent
      showPrimaryButton={false}
      showSecondaryButton={true}
      secondaryButtonTitle={commonLabels.close}
      onSecondaryButtonClick={onClose}
    >
      <ViewProgramFee
        programFeeDetailsData={
          programFeeDetailsData || ({} as GetProgramFeeResponse)
        }
        programData={generalDetail}
        pageId={pageId}
      />
    </MuiModal>
  );
};
